import React from "react";
import { CONFIG } from '../../../config';

const normalizeFileUploadsBaseUrl = (url) => {
    if (!url) return '';
    return url.replace(/\/+$/, '');
};

const RawFileUploadsModule = () => {
    const baseUrl = normalizeFileUploadsBaseUrl(CONFIG.file_uploads_url);
    const urlFileUploads = `${baseUrl}?screenSize=fullscreen`;

    if (!baseUrl) {
        return (
            <div className="box-center text-center mt-20">
                File uploads URL is not configured. Add <code>file_uploads_url</code> to runtime-config.js.
            </div>
        );
    }

    return (
        <div style={{ width: '100%' }}>
            <iframe
                style={{ display: 'block', width: '100%', minHeight: 800, border: 'none' }}
                src={urlFileUploads}
                title="RAW Data Upload"
            />
        </div>
    );
};

export default RawFileUploadsModule;
